import { gql } from '@apollo/client';
/**
 * @const DeleteEntityNoteMutation
 * @since 1.0.0
 */
export const DeleteEntityNoteMutation = gql `
  mutation DeleteEntityNoteMutation($input: DeleteEntityNoteInput!) {
    deleteEntityNote(input: $input)
  }
`;
